import script from "./WordByWord.vue?vue&type=script&setup=true&lang=js"
export * from "./WordByWord.vue?vue&type=script&setup=true&lang=js"

import "./WordByWord.vue?vue&type=style&index=0&id=59fa3742&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-59fa3742"]])

export default __exports__